
const SERVICE_NAME: string = 'TPISentry';

export class Sentry {
    public static testNativeException(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            cordova.exec((e: unknown) => {
                resolve();
            },
            reject,
            SERVICE_NAME,
            "testNativeException",
            []);
        });
    }
}
